import { UserControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useStatusUsers = () =>
  useMutationWithLoading(
    async (param: { userId: string; status: boolean; xTENANTID?: string }) =>
      new UserControllerApi(getConfigObject()).updateUserStatus(
        param.userId,
        param.status,
        param.xTENANTID //xTENANTID
      )
  );
